<template>
    <div 
        class="area-tile"
        :class="isWorkshop ? 'tile-workshop' : 'tile-zone'"
        @click="enableActionButtons()"
    >
        <div class="info-container">
            <div class="name-container">
                <div
                    class="tile-icon">
                    <v-icon
                        name="clone"
                    >
                    </v-icon>
                </div>
                <h2>{{ componentData.name }}</h2>
            </div>
            <div class="title-container">
                <ConsumptionPercentBadge
                    ref="consumptionPercentBadge"
                    :uid="componentData.uid"
                    entity="area"                   
                />
                <div class="tile-text">
                    <div class="meter-container">
                        <div class="meter-icon-container">
                            <img :src="energyMeterIcon(componentData.energy_meter)" alt="" class="meter-icon">
                        </div>
                        <span class="meter-name">{{ componentData.energy_meter_name }}</span>
                    </div>
                    <div
                        v-if="componentData.simulation_measure"
                        class="compute-icon"
                    >
                        <v-icon
                            name="check-circle"
                        ></v-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ConsumptionPercentBadge from '@/components/partials/ui/ConsumptionPercentBadge.vue';
    export default {
        name: 'WorkshopCard',
        components: {
            ConsumptionPercentBadge
        },
        props: {
            componentData: {
                type: Object,
                required: true
            }
        },
        computed: {
            ...mapGetters(['currentSite', 'energyMeterIcon']),
            isWorkshop() {
                return this.componentData.parent_area_uid === null;
            },
        },
        methods: {
            enableActionButtons(){
                this.$emit('enableActionButtons', this.componentData);
            },
            openWorkshopForm() {
                this.$store.commit('SET_CURRENT_AREA', { ...this.componentData });
                this.$router.push({
                    name: 'Area',
                    params: {
                        areaType: 'workshop',
                        siteUid: this.currentSite.uid,
                    }
                });
            },
            openZoneForm() {
                this.$router.push({
                    name: 'Area',
                    params: {
                        areaType: 'zone',
                        siteUid: this.currentSite.uid,
                        parentAreaUid: this.componentData.uid
                    }
                });
            },
            openEquipmentForm() {
                this.$router.push({
                    name: 'Equipment',
                    params: {
                        siteUid: this.currentSite.uid,
                        parentAreaUid: this.componentData.uid
                    }
                });
            },
            refreshConsumptionPercent(){
                this.$refs.consumptionPercentBadge.getConsumptionPercent();
            }
        },
    }
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/page/Synoptic/Areas/WorkshopCard.vue